import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { useTheme } from '@theme/useTheme';

interface CustomCheckboxProps {
  description: string;
  checked: boolean;
  onChange: (newValue: boolean) => void;
  disabled?: boolean;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  description,
  checked,
  onChange,
  disabled = false,
}) => {
  const { colors } = useTheme();

  const toggleCheckbox = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div className="flex items-start space-x-2 sm:space-x-3">
      <button
        onClick={toggleCheckbox}
        disabled={disabled}
        className={`flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5 border-2 rounded flex items-center justify-center transition-all duration-200 ${disabled
          ? 'cursor-not-allowed'
          : 'cursor-pointer'
          }`}
        style={{
          backgroundColor: checked && !disabled ? colors.primary : 'transparent',
          borderColor: checked && !disabled ? colors.primary : colors.border, // Theme border
        }}
      >
        {checked && (
          <FaCheck size={8} className="sm:hidden" style={{ color: 'white' }} />
        )}
        {checked && (
          <FaCheck size={10} className="hidden sm:block" style={{ color: 'white' }} />
        )}
      </button>

      <label
        onClick={toggleCheckbox}
        className={`flex-1 text-xs sm:text-sm leading-4 sm:leading-5 cursor-pointer select-none ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'
          }`}
        style={{
          color: disabled ? colors.text + '80' : colors.text
        }}
      >
        {description}
      </label>
    </div>
  );
};

export default CustomCheckbox;
